import React from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import { setIsEditItemPanelActive } from '../../../store/ui/uiSlice'

import { CardMedia, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'

import * as commonStyles from '../styles'
import * as styles from './styles'
import { useAppDispatch, useAppSelector } from '../../../hooks'

const Styled = {
  ...commonStyles,
  ...styles,
}

interface Props {
  itemsWithInfo: Array<{ id: string }>
  itemType: string
}

const ItemsAccordion: React.FC<Props> = ({ itemsWithInfo, itemType }) => {
  const configurator = useConfiguratorContext()
  const dispatch = useAppDispatch()

  const { assetBaseUrl, content } = useAppSelector((state) => state.init) || {}
  const { selectedItem } = useAppSelector((state) => state.selectedItem) || {}
  const { isEditItemPanelActive } = useAppSelector((state) => state.ui) || {}
  const { erpItems } = useAppSelector((state) => state.items) || {}

  if (!assetBaseUrl && !content && !selectedItem) return

  const getArticleAttributes = (article: any): any[] =>
    article.configData?.configResult?.configProducts[0].orderRowDescription
      .split(',')
      .map((dimension: string) => dimension.split(':'))

  const getEditorials = (article: any): any => {
    const matchingErpItems = erpItems.find((item) => item.Sku === article.erpItemNumber)
    if (matchingErpItems) return { ...article, ...matchingErpItems }
  }

  const handleChangeButtonClick = async (item: { id: string }): Promise<void> => {
    await configurator.selectItem(item.id)
    configurator.cameraToSelected()
    dispatch(setIsEditItemPanelActive(true))
  }

  return (
    <>
      {!itemsWithInfo.length ? (
        <Styled.Value>{content?.summary_panel.configuration[`no_${itemType}s`]}</Styled.Value>
      ) : (
        itemsWithInfo.map((item, index) => {
          const editorial = getEditorials(item)

          return (
            <Accordion key={editorial.Title + index} sx={{ boxShadow: 'none' }}>
              <AccordionSummary
                expandIcon={null}
                aria-controls="panel2-content"
                id="panel2-header"
                sx={{ alignItems: 'center', backgroundColor: 'transparent' }}
              >
                <CardMedia
                  component="img"
                  alt={editorial.Title}
                  // For refrence see this link https://mui.com/system/getting-started/the-sx-prop/
                  sx={{
                    width: 100,
                    height: 'auto',
                    m: '0 0 auto 0',
                    pl: 0,
                  }}
                  image={`${assetBaseUrl}/mediaarchive/s/images/${
                    editorial?.Title?.replaceAll('/', '-').replaceAll(' ', '-') || editorial.Sku
                  }/${editorial.Sku}?d=240x240`}
                />
                <Styled.AccordionSummaryTexts>
                  <Typography variant="subtitle2" sx={{ textTransform: 'none' }}>
                    {editorial.Title}
                  </Typography>
                  <Typography variant="caption">{editorial.TitleLong}</Typography>

                  <Styled.ChangeButton
                    onClick={() => {
                      handleChangeButtonClick(item).catch(console.error)
                    }}
                  >
                    {content.summary_panel.configuration.change_button}
                  </Styled.ChangeButton>
                </Styled.AccordionSummaryTexts>
              </AccordionSummary>
              <AccordionDetails>
                {!isEditItemPanelActive && (
                  <Styled.Attributes>
                    {getArticleAttributes(item)?.map((attribute, index) => (
                      <Styled.ListItem key={attribute[0] + index}>
                        <Typography variant="subtitle2" sx={{ textTransform: 'none' }}>
                          {attribute[0]}
                        </Typography>
                        <Typography variant="body2">{attribute[1]}</Typography>
                      </Styled.ListItem>
                    ))}
                  </Styled.Attributes>
                )}
              </AccordionDetails>
            </Accordion>
          )
        })
      )}
    </>
  )
}

export default ItemsAccordion
